var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphickArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L9.56569 3.56569C9.36768 3.36768 9.26867 3.26867 9.15451 3.23158C9.05409 3.19895 8.94591 3.19895 8.84549 3.23158C8.73133 3.26867 8.63232 3.36768 8.43432 3.56569L6.56569 5.43432C6.36768 5.63232 6.26867 5.73133 6.15451 5.76842C6.05409 5.80105 5.94591 5.80105 5.84549 5.76842C5.73133 5.73133 5.63232 5.63232 5.43432 5.43432L1 1M15 9L11 9M15 9L15 5",
    stroke: "#01A438",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphickArrow);
export default __webpack_public_path__ + "static/media/GraphickArrow.c6c282477a849fed4140cd4f9fabb1eb.svg";
export { ForwardRef as ReactComponent };